import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ModalForm from './ModalForm';

interface Props {
  tipoUsuario: number;
  setShow: (show: boolean) => void;
}

const Heading: FC<Props> = (props) => {
  const { tipoUsuario, setShow } = props;
  const { t } = useTranslation();
  const tipoForm = '';
  const getTexto = () => {
    switch (tipoUsuario) {
      default: {
        return t('datos.personaldata.heading');
      }
      case -1: {
        return '';
      }
      case 2: {
        return t('datos.personaldata.company-heading');
      }
    }
  };
  const text = getTexto();
  return (
    <h2 id="personales" className="bloque-datos__title u-text-brand">
      <span className="divider__square brand-color" />
      <span className="u-margin-right">{text}</span>
      <ModalForm setShow={setShow} tipoForm={tipoForm} />
    </h2>
  );
};

export default Heading;
